export enum OperatingTypes {
    OPERATING_TIME = 0,
    OPERATING_COUNT = 1
}

export const OPERATING_TIME_UNIT_NAME = 'timer';
export const OPERATING_COUNT_UNIT_NAME = 'slagtimer';